import * as React from 'react';
import { useAppSelector } from 'store/hooks';
import { HelpCallToAction, Spacer } from 'design-system';
import ListLoader from 'design-system/ListLoader';
import { muteErrorAndResult, useFetchOld } from 'hooks';
import { selectIsDefaultSpace } from 'features/spaces/reducers/selectors';
import { selectUserId } from 'reducers/selectors';
import Links from 'utils/links';
import { getPotActivities } from '../actions';
import { selectFirstFiveActivitiesForPot, selectFirstFivePendingActivitiesForPot, selectInitialActivitiesLoadingForPot, } from '../reducers/selectors';
import FSCSCard from './FSCSCard';
import PotsActivitySection from './PotsActivitySection';
import PotsGoalSection from './PotsGoalSection';
import PotsPendingActivitySection from './PotsPendingActivitySection';
import UpgradeComponent from './UpgradeComponent';
const PotsActivitiesContainer = ({ pot, hideSpaceUserAvatar }) => {
    const [, , fetching, fetch] = useFetchOld(muteErrorAndResult);
    const [, , fetchingPendingActivities, fetchPendingActivities] = useFetchOld(muteErrorAndResult);
    const myId = useAppSelector(selectUserId);
    const potOwnerUserId = pot.userId || myId;
    const isPotOwner = myId === potOwnerUserId;
    const isDefaultSpace = useAppSelector(selectIsDefaultSpace);
    const initialLoading = useAppSelector((state) => selectInitialActivitiesLoadingForPot(state, pot.id));
    const { slicedData: potsPendingActivities } = useAppSelector((state) => selectFirstFivePendingActivitiesForPot(state, pot.id));
    const { slicedData: potsActivities } = useAppSelector((state) => selectFirstFiveActivitiesForPot(state, pot.id));
    React.useEffect(() => {
        fetchPendingActivities(getPotActivities(pot.id, { status: 'PENDING', paging: { page: 1, perPage: 200 }, potOwnerUserId }));
        if (!initialLoading) {
            fetch(getPotActivities(pot.id, { status: 'COMPLETED', paging: { page: 1, perPage: 30 }, potOwnerUserId }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pot.id, potOwnerUserId]);
    const onHelpPress = React.useCallback(() => {
        Links.openKnownLink('potsHelp');
    }, []);
    if ((fetching || fetchingPendingActivities || initialLoading) &&
        !potsPendingActivities?.length &&
        !potsActivities?.length) {
        return <ListLoader extraSmallMargin/>;
    }
    return (<>
      <Spacer h={8}/>
      {(isDefaultSpace || isPotOwner) && !pot.deletedAt ? <PotsGoalSection pot={pot}/> : null}
      <Spacer h={16}/>
      {isDefaultSpace || isPotOwner ? (<UpgradeComponent showComponent={pot.type === 'INTEREST' || pot.type === 'INTEREST_NOTICE'} productId={pot.productId}/>) : null}
      <PotsPendingActivitySection hideSpaceUserAvatar={hideSpaceUserAvatar} pot={pot}/>
      <PotsActivitySection hideSpaceUserAvatar={hideSpaceUserAvatar} pot={pot}/>
      <HelpCallToAction onDark onPress={onHelpPress} subTitle="Learn about Emma Pots" title="Want to have more details?"/>
      {(pot?.type === 'INTEREST' ||
            pot?.type === 'INTEREST_NOTICE' ||
            pot?.type === 'ACCUMULATED_INTEREST' ||
            pot?.type === 'ACCUMULATED_INTEREST_NOTICE') && <FSCSCard productId={pot.productId}/>}
    </>);
};
export default PotsActivitiesContainer;
